//集团化官网
// 配置API接口地址
//let domain = 'hk.group.com' //本地开发，本地测试
//let domain = 'hkmo.group.com' //本地模测
let domain = document.domain;//测试 模测 线上打包

//let apiUrl = '/api' //本地
//let apiUrl = 'http://dev.gsite.com' //本地
//let apiUrl = 'http://b.eetopintest.com';//测试
//let apiUrl = 'http://shopmo.eetop.com';//模测
let apiUrl = window.location.protocol.indexOf('https') > -1 ? 'https://group-api.hzkqyyjt.com' : 'http://group-api.eetop.com';//线上

const cachePrex = 'Branch';

let baseURL;

if (/MSIE/i.test(navigator.appVersion) && /MSIE 9/i.test(navigator.appVersion)) {
    baseURL = 'http://'+ document.domain + '/api'
}else{
    baseURL = apiUrl
}

let url ='/front';
let groupIndex='/groupfront/index/index'
//index接口相关
let indexUrl=`${url}/index`
let index={
    index:`${indexUrl}/index`,//分院首页
    config:`${indexUrl}/config`,//通用参数
    getImgCode:`${indexUrl}/get-imgcode`,//获取验证码
    symptomList:`${indexUrl}/symptom-list`,//病症列表
    reservation:`${indexUrl}/reservation`,//预约
    search:`${indexUrl}/search`,//搜索
    moduleSeo: `${indexUrl}/seo`
}

let hospitalUrl=`${url}/hospital`
let hospital={
    index:`${hospitalUrl}/index`
}

let departmentUrl=`${url}/department`
let department={
    index:`${departmentUrl}/index`,
    detail:`${departmentUrl}/detail`,//详情
}

let doctorUrl=`${url}/doctor`;
let doctor={
    list:`${doctorUrl}/index`,//医生列表
    detail:`${doctorUrl}/detail`,//医生详情
    depList:`${doctorUrl}/dep-list`//医生列表下科室下拉
}

let dynamicUrl=`${url}/dynamic`
let dynamic={
    list:`${dynamicUrl}/index`,//动态列表
    detail:`${dynamicUrl}/detail`,//动态详情
}

let healthUrl=`${url}/health-education`
let health={
    list:`${healthUrl}/index`,//动态列表
    detail:`${healthUrl}/detail`,//动态详情
}

let recruitUrl=`${url}/recruit`;
let recruit={
    list:`${recruitUrl}/index`,//招贤纳士列表
    detail:`${recruitUrl}/detail`,//招贤纳士详情
    workplaces:'groupfront/recruit/workplaces',//工作地点列表
    departments:'groupfront/recruit/departments',//专业科室列表
}

export default{
    baseURL,
    domain,
    groupIndex,
    index,
    hospital,
    department,
    doctor,
    dynamic,
    health,
    recruit,
    cachePrex
}


// WEBPACK FOOTER //
// ./src/utils/api.js